import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { InfoIcon } from "@/assets/icons";
import { SERVICES } from "@/features/services";
import { Board, leadersAt } from "@/features/forecast/board";
import cls from "./BestCard.module.scss";

interface Props {
  board: Board;
  hour: number;
  cityName: string;
}

export const BestCard: React.FC<Props> = ({ board, hour, cityName }) => {
  const { t } = useTranslation();
  const { best, second } = leadersAt(board, hour);

  if (!best) {
    return (
      <div className={classNames(cls.best, cls.nodata)}>
        <div className={cls.nodataRow}>
          <InfoIcon />
          {t("compare.noDataCity", { city: cityName })}
        </div>
      </div>
    );
  }

  const svc = SERVICES[best.pick.k];
  const value = best.v[hour] as number;
  const cap = second
    ? t("compare.bestCap", {
        diff: value - (second.v[hour] as number),
        service: SERVICES[second.pick.k].gen,
        tariff: second.tnote,
      })
    : t("compare.bestSingle");

  return (
    <div className={cls.best}>
      <div className={cls.hlab}>{t("compare.bestLabel")}</div>
      <div className={cls.row}>
        <span className={cls.lg}>
          <img src={svc.logo} alt="" />
        </span>
        <div className={cls.nm}>{best.tnote}</div>
        <span className={cls.tarif}>{svc.name}</span>
      </div>
      <div className={cls.price}>
        {value.toLocaleString("ru-RU")} <em>₽/ч</em>
      </div>
      <div className={cls.cap}>{cap}</div>
    </div>
  );
};
